'use-strict';
var BlsLazyloadImg = (function () {
  return {
    init: function () {
      this.lazyReady();
    },
    lazyReady: function () {
      if (!!window.IntersectionObserver) {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const onImageLoad = (e) => {
                  const target = e.currentTarget;
                  setTimeout(() => {
                    target
                      ?.closest('motion-element')
                      ?.classList.remove('bls-loading-image');
                    target?.classList.remove('bls-loading-image');
                  }, 600);
                  e.currentTarget.removeEventListener('load', onImageLoad);
                };
                entry.target.width = entry.boundingClientRect.width;
                entry.target.height = entry.boundingClientRect.height;
                entry.target.sizes = `${entry.boundingClientRect.width}px`;
                entry.target.addEventListener('load', onImageLoad);
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '10px' },
        );
        document.querySelectorAll('.bls-image-js img').forEach((img) => {
          observer.observe(img);
        });
      }
    },
  };
})();
BlsLazyloadImg.init();
function CloseAllPopup(data) {
  publish('closeCanvas', data);
}

const imageReady = (imageOrArray) => {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray =
    imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(
    imageOrArray.map((image) => {
      return new Promise((resolve) => {
        if (
          (image.tagName === 'IMG' && image.complete) ||
          !image.offsetParent
        ) {
          setTimeout(() => {
            image
              .closest('motion-element')
              ?.classList.remove('bls-loading-image');
            image.classList.remove('bls-loading-image');
            resolve();
          }, 100);
        } else {
          image.addEventListener('load', (e) => {
            e.currentTarget
              .closest('motion-element')
              ?.classList.remove('bls-loading-image');
            e.currentTarget.classList.remove('bls-loading-image');
            resolve();
          });
        }
      });
    }),
  );
};

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
class SlideSection extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.cleanupFns = [];
    this.init();
  }

  disconnectedCallback() {
    this.cleanupFns.forEach((fn) => fn());
    this.cleanupFns = [];
  }

  init() {
    if (document.body.classList.contains('index')) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains('swiper-lazy')) {
        this.initSlide();
      } else {
        if (this.classList.contains('lazy-loading-swiper-before')) {
          this.initSlide();
        } else {
          this.classList.add('lazy-loading-swiper-after');
        }
      }
    } else {
      this.initSlide();
    }
  }

  // Helper function to update active-index-display with retry mechanism
  updateActiveIndexDisplay(element, index, retries = 3) {
    const activeIndexDisplay = element.querySelector('.active-index-display');
    if (activeIndexDisplay) {
      activeIndexDisplay.innerHTML = index;
      return true;
    } else if (retries > 0) {
      // Retry after a short delay if element not found
      setTimeout(() => {
        this.updateActiveIndexDisplay(element, index, retries - 1);
      }, 50);
    }
    return false;
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === 'true';
    const loop = _this?.dataset.loop === 'true';
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : '';
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : 'horizontal';
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : 'slide';
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === 'true';
    const autoItem = _this?.dataset.itemMobile === 'true';
    const autoHeight = _this?.dataset.autoHeight === 'true';
    const paginationCustom = _this?.dataset.customPagination;
    const slideShow = _this?.dataset.slideshow === 'true';
    const revealSlideshow = _this?.dataset.revealSlideshow === 'true';
    const customNavigation = _this?.dataset.customNavigation === 'true';
    const customPrev = _this?.dataset.customPrev;
    const customNext = _this?.dataset.customNext;
    const noSwipingClass = _this?.dataset?.noSwipingClass || 'size-overlay';
    const noSwipingSelector = `.${noSwipingClass}, .swiper-no-swiping`;
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == 'vertical') {
      _this.style.maxHeight = _this.offsetHeight + 'px';
    }

    this.globalSlide = new Swiper(_this, {
      noSwipingClass,
      noSwipingSelector,
      slidesPerView: autoItem ? 'auto' : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      fadeEffect: {
        crossFade: true,
      },
      autoHeight: autoHeight,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      centeredSlides: false,
      grabCursor: true,
      grid: {
        rows: row,
        fill: 'row',
      },
      navigation: {
        nextEl: customNavigation
          ? document.querySelector(`.${customNext}`)
          : _this.querySelector('.swiper-button-next'),
        prevEl: customNavigation
          ? document.querySelector(`.${customPrev}`)
          : _this.querySelector('.swiper-button-prev'),
      },
      pagination: {
        clickable: true,
        el:
          paginationCustom == undefined
            ? _this.querySelector('.parent-pagination') ||
              _this.querySelector('.swiper-pagination')
            : _this.querySelector(`.${paginationCustom}`),
        type: progressbar ? 'progressbar' : 'bullets',
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          type: progressbar ? 'progressbar' : 'bullets',
          autoHeight: false,
          centeredSlides: false,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          type: progressbar ? 'progressbar' : 'bullets',
          autoHeight: false,
          centeredSlides: slideShow && itemDesktop == 1.5 ? true : false,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          var sec__tiktok = _this.closest('.sec__tiktok-video');
          e.autoplay.stop();
          if (_this?.dataset.autoplay === 'true') {
            Motion.inView(
              _this,
              async () => {
                e.autoplay.start();
              },
              { margin: '0px 0px -50px 0px' },
            );
          }

          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener('resize', function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              '.product-item__media--ratio',
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = '--arrows-offset-top: ' + max + 'px';
              if (_this.querySelectorAll('.swiper-arrow')) {
                _this.querySelectorAll('.swiper-arrow').forEach((arrow) => {
                  arrow.setAttribute('style', arrowsOffset);
                });
              }
            }
          }
          var video = _this.querySelector('video.slideshow');
          if (video) {
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return;
              observer.unobserve(_this);
              const videos = _this.querySelectorAll('video');
              videos.forEach((video) => {
                const dataSrc = video.dataset.src;
                if (dataSrc) {
                  video.src = dataSrc;
                  video.removeAttribute('data-src');
                }
              });
            };
            new IntersectionObserver(handleIntersection.bind(_this), {
              rootMargin: '0px 0px 200px 0px',
            }).observe(_this);
          }

          // Initialize active-index-display on init
          // const initialIndex = e.realIndex + 1;
          // console.log('Initial index: ');
          // console.log(initialIndex);
          // _this.updateActiveIndexDisplay(_this, initialIndex);
          // Only vertical slideshows need a fixed shared max-height. Applying it
          // to horizontal carousels locks the .swiper height to a single
          // init-time measurement and clips card content (e.g. the price row)
          // when that measurement races font/image/breakpoint layout.
          const swiperWrapper = _this.querySelector('.swiper-wrapper');
          if (swiperWrapper && direction === 'vertical') {
            _this.setupVerticalMaxHeight(swiperWrapper);
          }
        },
        slideChange: function (swiper) {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest('.sec__testimonials-single')) {
            const allDots = _this
              .closest('.sec__testimonials-single')
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove('active');
            });
            _this
              .closest('.sec__testimonials-single')
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']",
              )
              .classList.add('active');
          }

          // Update active-index-display (backup to realIndexChange)
          const swiperNavigation = _this.querySelector(
            '.natuno-swiper-navigation',
          );

          const activeIndexDisplay = _this.querySelector(
            '.active-index-display',
          );
          if (activeIndexDisplay) {
            const initialDisplayCount = parseInt(
              swiperNavigation.dataset?.displayCount || 1,
            );

            const updatedRenderedItemCount =
              initialDisplayCount + (index_currentSlide - 1);

            activeIndexDisplay.innerHTML = updatedRenderedItemCount;
          } else {
            // Retry if element not found (for lazy loaded sliders)
            setTimeout(() => {
              const retryDisplay = _this.querySelector('.active-index-display');
              if (retryDisplay) {
                const initialDisplayCount = parseInt(
                  swiperNavigation.dataset?.displayCount || 1,
                );

                const updatedRenderedItemCount =
                  initialDisplayCount + (index_currentSlide - 1);

                retryDisplay.innerHTML = updatedRenderedItemCount;
              }
            }, 50);
          }
        },
        slideChangeTransitionStart: function () {
          if (!slideShow) return;
          const currentSlide = this.slides[this.activeIndex];
          currentSlide
            .querySelectorAll('motion-element')
            .forEach(async (motion) => {
              await motion.preInitialize();
            });
        },
        slideChangeTransitionEnd: function () {
          if (!slideShow) return;
          const currentSlide = this.slides[this.activeIndex];
          currentSlide
            .querySelectorAll('motion-element')
            .forEach(async (motion) => {
              (motion.classList.remove('animate-delay'),
                await motion.initialize());
            });

          // Additional backup: update after transition completes
          const index_currentSlide = this.realIndex + 1;
          const activeIndexDisplay = _this.querySelector(
            '.active-index-display',
          );
          if (activeIndexDisplay) {
            activeIndexDisplay.innerHTML = index_currentSlide;
          } else {
            // Retry if element not found (for lazy loaded sliders)
            setTimeout(() => {
              const retryDisplay = _this.querySelector('.active-index-display');
              if (retryDisplay) {
                retryDisplay.innerHTML = index_currentSlide;
              }
            }, 50);
          }
        },
        afterInit: function () {
          if (slideShow && revealSlideshow && itemDesktop <= 3) {
            _this.duplicateSlides(this);
          }
        },
        tap: function (swiper, event) {
          const target = event.target.closest('.size-overlay');
          if (target) {
            swiper.allowTouchMove = false;
          }
        },
        touchMove: function (swiper, event) {
          const innerWidth = event.view.innerWidth;
          const swiperMedia =
            swiper.el.classList.contains('swiper-popup-media');
          const slidePopup = document.querySelector('slide-section-popup');
          if (slidePopup && swiperMedia && innerWidth > 767) {
            slidePopup.swiper.allowTouchMove = false;
            slidePopup.swiper.unsetGrabCursor();
          }
        },
        touchEnd: function (swiper, event) {
          // re-enable for the next gesture, regardless of where this one started
          swiper.allowTouchMove = true;

          const innerWidth = event.view.innerWidth;
          const swiperMedia =
            swiper.el.classList.contains('swiper-popup-media');
          const slidePopup = document.querySelector('slide-section-popup');
          if (!swiperMedia) return;
          if (slidePopup && innerWidth > 767) {
            slidePopup.swiper.allowTouchMove = true;
            slidePopup.swiper.setGrabCursor();
          }
        },
      },
    });
  }

  getMaximumSlideContent() {
    const slides = this.querySelectorAll('.swiper-slide');
    let maxHeight = 0;

    slides.forEach((slide) => {
      const height = slide.scrollHeight;

      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    return maxHeight;
  }

  setupVerticalMaxHeight(swiperWrapper) {
    const _this = this;

    const applyMaxHeight = () => {
      const height = _this.getMaximumSlideContent();
      if (height) {
        _this.style.maxHeight = height + 'px';
      }
    };

    // Initial best-effort measurement right away
    applyMaxHeight();

    // --- MutationObserver: catch async content (e.g. countdown render) ---
    let measured = false;
    let fallbackTimer = null;

    const cleanupMutationWatch = () => {
      measured = true;
      mutationObserver.disconnect();
      if (fallbackTimer) clearTimeout(fallbackTimer);
    };

    const mutationObserver = new MutationObserver(() => {
      if (measured) return;
      applyMaxHeight();
      cleanupMutationWatch();
    });

    mutationObserver.observe(swiperWrapper, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    fallbackTimer = setTimeout(() => {
      if (!measured) cleanupMutationWatch();
    }, 3000);

    this.cleanupFns.push(cleanupMutationWatch);

    // --- Resize handling: re-measure when text reflows (breakpoint changes, etc.) ---
    let resizeTimer = null;

    const handleResize = () => {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        applyMaxHeight();
      }, 150); // debounce so rapid resize events don't thrash layout
    };

    window.addEventListener('resize', handleResize);

    this.cleanupFns.push(() => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimer) clearTimeout(resizeTimer);
    });
  }
  duplicateSlides(swiper) {
    const _this = this;
    const swiperWrapper = _this.querySelector('.swiper-wrapper');
    const originalSlides = swiperWrapper.querySelectorAll('.swiper-slide');
    const paginationEl = _this.querySelector('.swiper-pagination');
    if (paginationEl) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (
                node.nodeType === 1 &&
                node.classList.contains('swiper-pagination-bullet')
              ) {
                const allBullets = paginationEl.querySelectorAll(
                  '.swiper-pagination-bullet',
                );
                const bulletIndex = Array.from(allBullets).indexOf(node);
                if (bulletIndex >= originalSlides.length) {
                  node.classList.add('swiper-pagination-duplicate');
                }
              }
            });
          }
        });
        observer.disconnect();
      });

      observer.observe(paginationEl, { childList: true });
    }

    originalSlides.forEach((slide) => {
      const clonedSlide = slide.cloneNode(true);
      clonedSlide.classList.add('swiper-slide-duplicate');
      swiperWrapper.appendChild(clonedSlide);
    });

    swiper.update();
  }

  initSecTiktok(sec) {
    sec.querySelectorAll('.swiper-slide').forEach((arrow) => {
      const tiktok = arrow.querySelector('.section_tiktok-image');
      let width = '--item-width: ' + arrow.offsetWidth;
      tiktok.setAttribute('style', width);
    });
  }
}
customElements.define('slide-section', SlideSection);

class SlideSectionPagination extends HTMLElement {
  slideSection = null;
  nextBtnSelector = '.custom-swiper-button-next';
  prevBtnSelector = '.custom-swiper-button-prev';
  contentShownIndexLabelSelector = '.custom-swiper-content-index-label';
  contentTotalSlidesSelector = '.custom-swiper-content-total-slides';
  swiper = null;
  loop = false;
  customPagination = 'show';
  constructor() {
    super();
  }

  connectedCallback() {
    // Wait for parent slide-section to have its swiper ready
    customElements.whenDefined('slide-section').then(() => {
      const slideSection = this.closest('slide-section');
      if (!slideSection) return;
      this.loop = slideSection.dataset?.loop === 'true';
      this.waitForSwiper(slideSection);
    });
  }

  waitForSwiper(slideSection) {
    // If swiper already initialized
    if (slideSection.globalSlide) {
      this.initSwiper(slideSection.globalSlide);
      return;
    }

    // Poll until swiper is ready (handles lazy init)
    const interval = setInterval(() => {
      if (slideSection.globalSlide) {
        clearInterval(interval);
        this.initSwiper(slideSection.globalSlide);
      }
    }, 100);

    // Safety timeout — stop polling after 10s
    setTimeout(() => clearInterval(interval), 10000);
  }

  initSwiper(swiper) {
    this.swiper = swiper;
    this.updateRender();
    this.setupListener();
    this.updateTotalSlides();
    this.setupSwiperEvents();
  }

  setupSwiperEvents() {
    if (!this.swiper) return;

    this.swiper.on('slideChangeTransitionEnd', () => {
      this.updateRender();
    });

    this.swiper.on('touchEnd', () => {
      requestAnimationFrame(() => {
        this.updateRender();
      });
    });

    this.swiper.on('breakpoint', () => {
      this.updateRender();
    });
  }

  updateRender(swiper) {
    const prevBtn = this.querySelector(this.prevBtnSelector);
    const nextBtn = this.querySelector(this.nextBtnSelector);
    const _swiper = swiper || this.swiper;

    if (this.loop) {
      prevBtn.removeAttribute('disabled');
      nextBtn.removeAttribute('disabled');
    } else {
      if (_swiper.isBeginning) {
        prevBtn.setAttribute('disabled', true);
      } else {
        prevBtn.removeAttribute('disabled');
      }
      if (_swiper.isEnd) {
        nextBtn.setAttribute('disabled', true);
      } else {
        nextBtn.removeAttribute('disabled');
      }
    }

    this.updateContentShownLabel();
  }

  updateTotalSlides() {
    if (!this.swiper) return false;

    const labelContainer = this.querySelector(this.contentTotalSlidesSelector);

    if (labelContainer) {
      labelContainer.textContent = this.swiper.slides.length;
    }
  }

  updateContentShownLabel() {
    if (!this.swiper || this.customPagination === 'hidden') return;

    const index = this.swiper.realIndex;
    const contentShown = parseInt(this.swiper.params?.slidesPerView);

    const totalContentShown = contentShown + index;

    const labelContainer = this.querySelector(
      this.contentShownIndexLabelSelector,
    );
    if (!labelContainer) return;
    labelContainer.textContent = totalContentShown;
  }

  setupListener() {
    this.addEventListener('click', (e) => {
      const nextBtn = e.target.closest(this.nextBtnSelector);

      const prevBtn = e.target.closest(this.prevBtnSelector);

      if (nextBtn) {
        this.handleNext();
      }
      if (prevBtn) {
        this.handlePrev();
      }
    });
  }

  handleNext() {
    if (!this.swiper) return;

    this.swiper.slideNext();
    this.updateRender();
  }

  handlePrev() {
    if (!this.swiper) return;

    this.swiper.slidePrev();
    this.updateRender();
  }
}
customElements.define('slide-section-pagination', SlideSectionPagination);

class PopupBase extends HTMLElement {
  constructor() {
    super();
    this.customClass = this.dataset.customClass;
    this.modal = null;
  }

  initPopup(content, text, customClass, modalWidth) {
    const _this = this;
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        const modalBoxContent = this.modal.querySelector('.tingle-modal-box');
        if (modalWidth) {
          modalBoxContent.style.setProperty('--popup-max-width', modalWidth);
        }
        document.dispatchEvent(new CustomEvent('modal:opened'));
        document.documentElement.classList.add('open-popup');
        root.style.setProperty(
          'padding-right',
          getScrollBarWidth.init() + 'px',
        );
        const video = this.modalBox.querySelector('video');
        if (!video) return;
        video.play();
        if (this.modal.classList.contains('shopable-video')) {
          video.muted = false;
        }
      },
      onClose: function () {
        document.dispatchEvent(new CustomEvent('modal:closed'));
        document.documentElement.classList.remove('open-popup');
        root.style.removeProperty('padding-right');
      },
      beforeClose: function () {
        _this.onCloseEvent();
        document.documentElement.classList.remove('open-popup');
        root.style.removeProperty('padding-right');
        return true;
      },
    });
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent;
      let popup_header = document.createElement('div');
      popup_header.classList.add('tingle-modal-box__header');
      popup_header.innerHTML = content;
      let parentElement = popup_content.parentNode;
      parentElement.insertBefore(popup_header, popup_content);
    };
    if (text) {
      this.modal.setHeader(text);
    }

    this.modal.setContent(content);
    this.modal.open();
  }

  onClose() {
    this.modal?.close();
  }
  onCloseEvent() {}
}

class SwatchInit extends HTMLElement {
  constructor() {
    super();
    this.options = null;
    this.init();
  }

  init() {
    const _this = this;
    this.querySelectorAll('.product__color-swatches--js').forEach((btn) => {
      _this.checkSwatches(btn);
    });
  }
  checkSwatches(e) {
    const { color, image, customValue, swatchType, optionSwatchValue } =
      e.dataset;
    if (color) {
      if (swatchType != 'variant_images') {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
            if (image) {
              e.classList.add('color__' + color.replace(' ', '-'));
              e.style.backgroundColor = null;
              e.style.backgroundImage = "url('" + image + "')";
              e.style.backgroundSize = 'cover';
              e.style.backgroundRepeat = 'no-repeat';
            }
          }
        } else {
          e.style.setProperty('--swatch--background', optionSwatchValue);
        }
      } else {
        if (optionSwatchValue == null || optionSwatchValue.length == 0) {
          if (image) {
            e.classList.add('color__' + color.replace(' ', '-'));
            e.style.backgroundColor = null;
            e.style.backgroundImage = "url('" + image + "')";
            e.style.backgroundSize = 'cover';
            e.style.backgroundRepeat = 'no-repeat';
          } else if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
          }
        } else {
          e.style.setProperty('--swatch--background', optionSwatchValue);
        }
      }
    }
  }
  checkColor(strColor) {
    var s = new Option().style;
    s.color = strColor;
    return s.color == strColor;
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('.product__color-swatches--js.active'),
      (select) => select.getAttribute('data-value'),
    );
    this.variantData.find((variant) => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }));
  }
}

// js for 3d product - not done yet
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe'),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == 'VIDEO' &&
        deferredElement.getAttribute('autoplay')
      ) {
        deferredElement.play();
      }
    }
  }
}

function handleErrorMessagePopup(errorMessage = false) {
  const url = `${window.location.pathname}?section_id=form-message`;
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const elementErrorMessage = html.querySelector(
        '.product-form__error-message-wrapper',
      );
      const elementMessage = elementErrorMessage.querySelector(
        '.product-form__error-message',
      );
      elementMessage.textContent = errorMessage;
      showToast(elementErrorMessage.innerHTML, 5000, 'modal-error');
    })
    .catch((e) => {
      throw e;
    });
}

function showToast(message, duration = 3000, customClass = '') {
  let toastContainer = document.getElementById('toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'toast-container';
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement('div');
  toast.className = `toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  Motion.animate(
    toast,
    {
      opacity: [0, 1],
      scale: [0.3, 1],
    },
    {
      duration: 0.3,
      easing: 'ease-out',
    },
  );

  setTimeout(() => {
    closeToast(toast);
  }, duration);
}

function showCartToast(message, duration = 3000, customClass = '') {
  let toastContainer = document.getElementById('cart-toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'cart-toast-container';
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement('div');
  toast.className = `cart-toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  Motion.animate(
    toast,
    {
      opacity: [0, 1],
      scale: [0.3, 1],
    },
    {
      duration: 0.3,
      easing: 'ease-out',
    },
  );

  setTimeout(() => {
    closeCartToast(toast);
  }, duration);
}

function closeToast(toast) {
  Motion.animate(
    toast,
    { opacity: 0, scale: 0.5 },
    { duration: 0.2, easing: 'ease-in' },
  ).then(() => {
    toast.remove();
  });
}

function closeCartToast(toast) {
  Motion.animate(
    toast,
    { opacity: 0, scale: 0.5 },
    { duration: 0.2, easing: 'ease-in' },
  ).then(() => {
    toast.remove();
  });
}
// START -> Add to cart Notification
const TOAST_GAP = 0; // space between header and toast (px)
const TOAST_DEDUPE_MS = 300;

/**
 * rAF-based dismiss timer that pauses while the toast is hovered or focused.
 */
function startToastTimer(toast, duration) {
  let remaining = duration;
  let last = null;
  let rafId = null;

  function tick(now) {
    // Stop if the toast was closed or removed by something else
    if (toast.dataset.closing || !toast.isConnected) return;

    if (last === null) last = now; // first frame after (re)start: no time elapsed
    remaining -= now - last;
    last = now;

    if (remaining <= 0) {
      closeAddToCartToast(toast);
      return;
    }
    rafId = requestAnimationFrame(tick);
  }

  function resume() {
    cancelAnimationFrame(rafId);
    last = null;
    rafId = requestAnimationFrame(tick);
  }

  function pause() {
    cancelAnimationFrame(rafId);
  }

  // Mouse only: touch "hover" can stick after a tap and keep the toast open forever
  const onEnter = (e) => {
    if (e.pointerType === 'mouse') pause();
  };
  const onLeave = (e) => {
    if (e.pointerType === 'mouse') resume();
  };

  toast.addEventListener('pointerenter', onEnter);
  toast.addEventListener('pointerleave', onLeave);
  // Keyboard users: pause while anything inside the toast has focus
  toast.addEventListener('focusin', pause);
  toast.addEventListener('focusout', resume);

  resume();
}

function getToastTop() {
  const sectionHeader = document.querySelector('.section-header');
  if (sectionHeader) {
    // Below the header. Clamp to 0 so the toast never goes off-screen
    // when a non-sticky header has scrolled out of view.
    const { bottom } = sectionHeader.getBoundingClientRect();
    return Math.max(bottom, 0) + TOAST_GAP;
  }
  return 0;
}

let toastPositionRaf = null;
function updateToastPosition() {
  const container = document.getElementById('add-to-cart-toast-container');
  if (!container) return;
  cancelAnimationFrame(toastPositionRaf);
  toastPositionRaf = requestAnimationFrame(() => {
    container.style.top = `${getToastTop()}px`;
  });
}

/**
 * Returns a debounced version of `fn` that only runs `wait` ms after
 * the last call. Optional `immediate` runs on the leading edge instead.
 */
function debounce(fn, wait = 100, immediate = false) {
  let timeoutId = null;

  return function debounced(...args) {
    const callNow = immediate && timeoutId === null;

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      timeoutId = null;
      if (!immediate) fn.apply(this, args);
    }, wait);

    if (callNow) fn.apply(this, args);
  };
}

const debouncedUpdateToastPosition = debounce(updateToastPosition, 500);

function getToastContainer() {
  let container = document.getElementById('add-to-cart-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'add-to-cart-toast-container';
    container.setAttribute('role', 'status');
    container.setAttribute('aria-live', 'polite');
    document.body.appendChild(container);

    // Keep the position in sync with sticky / hide-on-scroll headers.
    // Registered once, when the container is first created.
    window.addEventListener('scroll', debouncedUpdateToastPosition, {
      passive: true,
    });
    window.addEventListener('resize', debouncedUpdateToastPosition);
  }
  return container;
}

function closeAddToCartToast(toast) {
  if (!toast || toast.dataset.closing) return;
  toast.dataset.closing = 'true';

  Motion.animate(
    toast,
    { opacity: [1, 0], scale: [1, 0.9] },
    { duration: 0.2, easing: 'ease-in' },
  ).finished.then(() => toast.remove());
}

function showAddToCartToast(
  message,
  duration = 3000,
  customClass = '',
  { dedupe = true },
) {
  // Ignore duplicate calls fired in quick succession
  if (dedupe) {
    const now = performance.now();
    if (now - (window.__lastToastAt || -Infinity) < TOAST_DEDUPE_MS) return;
    window.__lastToastAt = now;
  }

  const toastContainer = getToastContainer();
  toastContainer.style.top = `${getToastTop()}px`;

  const toast = document.createElement('div');
  toast.className = `add-to-cart-toast show ${customClass}`.trim();
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  Motion.animate(
    toast,
    { opacity: [0, 1], scale: [0.3, 1] },
    { duration: 0.3, easing: 'ease-out' },
  );

  startToastTimer(toast, duration);
}

// END -> Add to cart Notification
class SlideLazyLoad {
  constructor(e) {
    ((this.triggerEventsJs = e),
      (this.eventOptionsJs = { passive: !0 }),
      (this.userEventListenerJs = this.triggerListenerJs.bind(this)),
      (this.delayedScriptsJs = { normal: [], async: [], defer: [] }));
  }
  triggerListenerJs() {
    (this._removeUserInteractionListenerJs(this),
      'loading' === document.readyState
        ? document.addEventListener(
            'DOMContentLoaded',
            this._loadEverythingReadyNow.bind(this),
          )
        : this._loadEverythingReadyNow());
  }
  _removeUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.removeEventListener(t, e.userEventListenerJs, e.eventOptionsJs),
    );
  }
  _addUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.addEventListener(t, e.userEventListenerJs, e.eventOptionsJs),
    );
  }
  _preloadAllScriptsJs() {
    document.body.classList.add('swiper-lazy');
    document.body.classList.add('review-lazy');
    const loadingSwiper = document.querySelectorAll(
      '.lazy-loading-swiper-after',
    );
    loadingSwiper.forEach((el) => {
      el.classList.remove('lazy-loading-swiper-after');
      this.initSlide(el);
    });
    const reviewProduct = document.querySelectorAll('.review-product-added');
    reviewProduct.forEach((el) => {
      el.classList.remove('review-product-added');
      el.innerHTML = el.querySelector('.product-review-json').innerHTML;
      el.classList.remove('inline-loading');
    });
  }

  initSlide(el) {
    const _this = el;
    var autoplaying = _this?.dataset.autoplay === 'true';
    const loop = _this?.dataset.loop === 'true';
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : '';
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : 'horizontal';
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : 'slide';
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === 'true';
    const autoItem = _this?.dataset.itemMobile === 'true';
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == 'vertical') {
      _this.style.maxHeight = _this.offsetHeight + 'px';
    }
    _this.globalSlide = new Swiper(el, {
      slidesPerView: autoItem ? 'auto' : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: 'row',
      },
      navigation: {
        nextEl: _this.querySelector('.swiper-button-next'),
        prevEl: _this.querySelector('.swiper-button-prev'),
      },
      pagination: {
        clickable: true,
        el:
          _this.querySelector('.parent-pagination') ||
          _this.querySelector('.swiper-pagination'),
        type: progressbar ? 'progressbar' : 'bullets',
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          pagination: {
            type: progressbar ? 'progressbar' : 'bullets',
          },
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          pagination: {
            type: progressbar ? 'progressbar' : 'bullets',
          },
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          e.autoplay.stop();
          if (_this?.dataset.autoplay === 'true') {
            Motion.inView(
              _this,
              async () => {
                e.autoplay.start();
              },
              { margin: '0px 0px -50px 0px' },
            );
          }
          var sec__tiktok = _this.closest('.sec__tiktok-video');
          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener('resize', function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              '.product-item__media--ratio',
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = '--arrows-offset-top: ' + max + 'px';
              if (_this.querySelectorAll('.swiper-arrow')) {
                _this.querySelectorAll('.swiper-arrow').forEach((arrow) => {
                  arrow.setAttribute('style', arrowsOffset);
                });
              }
            }
          }

          // Initialize active-index-display on init (for lazy loaded sliders)
          const initialIndex = e.realIndex + 1;
          // Use setTimeout to ensure DOM is ready for lazy loaded sliders
          setTimeout(() => {
            const activeIndexDisplay = _this.querySelector(
              '.active-index-display',
            );
            if (activeIndexDisplay) {
              activeIndexDisplay.innerHTML = initialIndex;
            }
          }, 0);
        },
        realIndexChange: function (swiper) {
          var slide_visibles = _this.querySelectorAll(
            '.swiper-slide motion-element:not([data-image])',
          );
          slide_visibles?.forEach((slide) => {
            if (!slide.hasAttribute('hold')) {
              slide?.setAttribute('hold', true);
            }
          });

          // Update active-index-display when real index changes (more reliable than slideChange)
          const index_currentSlide = swiper.realIndex + 1;
          const activeIndexDisplay = _this.querySelector(
            '.active-index-display',
          );
          if (activeIndexDisplay) {
            activeIndexDisplay.innerHTML = index_currentSlide;
          } else {
            // Retry if element not found (for lazy loaded sliders)
            setTimeout(() => {
              const retryDisplay = _this.querySelector('.active-index-display');
              if (retryDisplay) {
                retryDisplay.innerHTML = index_currentSlide;
              }
            }, 50);
          }
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest('.sec__testimonials-single')) {
            const allDots = _this
              .closest('.sec__testimonials-single')
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove('active');
            });
            _this
              .closest('.sec__testimonials-single')
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']",
              )
              .classList.add('active');
          }

          // Update active-index-display (backup to realIndexChange)
          const activeIndexDisplay = _this.querySelector(
            '.active-index-display',
          );
          if (activeIndexDisplay) {
            activeIndexDisplay.innerHTML = index_currentSlide;
          } else {
            // Retry if element not found (for lazy loaded sliders)
            setTimeout(() => {
              const retryDisplay = _this.querySelector('.active-index-display');
              if (retryDisplay) {
                retryDisplay.innerHTML = index_currentSlide;
              }
            }, 50);
          }
        },
        slideChangeTransitionEnd: function () {
          // Additional backup: update after transition completes
          const index_currentSlide = this.realIndex + 1;
          const activeIndexDisplay = _this.querySelector(
            '.active-index-display',
          );
          if (activeIndexDisplay) {
            activeIndexDisplay.innerHTML = index_currentSlide;
          } else {
            // Retry if element not found (for lazy loaded sliders)
            setTimeout(() => {
              const retryDisplay = _this.querySelector('.active-index-display');
              if (retryDisplay) {
                retryDisplay.innerHTML = index_currentSlide;
              }
            }, 50);
          }
        },
      },
    });
  }

  async _loadEverythingReadyNow() {
    (this._preloadAllScriptsJs(),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.normal),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.defer),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.async),
      await this._triggerDOMContentLoadedJs(),
      await this._triggerWindowLoadJs(),
      window.dispatchEvent(new Event('glozinspeed-allScriptsLoaded')));
  }
  async _loadScriptsFromListJs(e) {
    const t = e.shift();
    return t
      ? (await this._transformScript(t), this._loadScriptsFromListJs(e))
      : Promise.resolve();
  }
  async _transformScript(e) {
    return (
      await this._requestAnimFrame(),
      new Promise((t) => {
        const s = document.createElement('script');
        let n;
        ([...e.attributes].forEach((e) => {
          let t = e.nodeName;
          'type' !== t &&
            ('data-glozinlazy-type' === t && ((t = 'type'), (n = e.nodeValue)),
            s.setAttribute(t, e.nodeValue));
        }),
          e.hasAttribute('src')
            ? (s.addEventListener('load', t), s.addEventListener('error', t))
            : ((s.text = e.text), t()),
          e.parentNode.replaceChild(s, e));
      })
    );
  }
  async _triggerDOMContentLoadedJs() {
    ((this.domReadyFired = !0),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event('glozinspeed-DOMContentLoaded')),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event('glozinspeed-DOMContentLoaded')),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event('glozinspeed-readystatechange')),
      await this._requestAnimFrame(),
      document.glozinonreadystatechange && document.glozinonreadystatechange());
  }
  async _triggerWindowLoadJs() {
    (await this._requestAnimFrame(),
      window.dispatchEvent(new Event('glozinspeed-load')),
      await this._requestAnimFrame(),
      window.glozinonload && window.glozinonload(),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event('glozinspeed-pageshow')),
      await this._requestAnimFrame(),
      window.glozinonpageshow && window.glozinonpageshow());
  }
  async _requestAnimFrame() {
    return new Promise((e) => requestAnimationFrame(e));
  }
  static run() {
    const e = new SlideLazyLoad([
      'keydown',
      'mousemove',
      'touchmove',
      'touchstart',
      'touchend',
      'wheel',
    ]);
    e._addUserInteractionListenerJs(e);
  }
}
SlideLazyLoad.run();

// js for copy button
class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.content = this.dataset.content;
    this.init();
  }
  init() {
    if (this.content) {
      this.addEventListener('click', this.onClick.bind(this));
    }
  }
  onClick() {
    navigator.clipboard.writeText(this.content);
    this.classList.add('copied');
  }
  updateUrl(newContent) {
    this.content = newContent;
  }
}
customElements.define('copy-button', CopyButton);

window.toast = function toast(message, type = 'success') {
  const isSuccess = type === 'success';
  const iconColor = isSuccess ? '#137F24' : '#D0473E';
  const className = isSuccess
    ? 'newsletter-form__message--success success'
    : 'line-item-error-1 error';
  const modalType = isSuccess ? 'modal-success' : 'modal-error';

  const iconPath = isSuccess
    ? `<path d="m6.033 8.992 1.972 1.98 3.952-3.96"/><path d="M7.973 1.178c.565-.482 1.49-.482 2.062 0l1.293 1.113c.245.213.704.385 1.03.385h1.392c.867 0 1.579.712 1.579 1.579v1.39c0 .32.172.786.384 1.032l1.113 1.292c.483.565.483 1.49 0 2.062l-1.113 1.293a1.813 1.813 0 0 0-.384 1.03v1.392c0 .867-.712 1.579-1.58 1.579h-1.39c-.32 0-.786.172-1.031.384l-1.293 1.113c-.564.483-1.489.483-2.062 0L6.681 15.71a1.813 1.813 0 0 0-1.031-.384H4.234c-.867 0-1.579-.712-1.579-1.58v-1.398c0-.32-.172-.778-.376-1.023l-1.105-1.301c-.474-.565-.474-1.48 0-2.045L2.28 6.677c.204-.246.376-.704.376-1.023V4.247c0-.868.712-1.58 1.58-1.58H5.65c.319 0 .785-.171 1.03-.384l1.293-1.105Z"/>`
    : `<path d="M7.977 1.198c.573-.482 1.498-.482 2.054 0l1.293 1.105a1.89 1.89 0 0 0 1.039.376h1.39c.868 0 1.58.712 1.58 1.58v1.39c0 .328.171.786.376 1.031l1.105 1.293c.482.573.482 1.497 0 2.054l-1.105 1.292c-.204.246-.376.704-.376 1.031v1.391c0 .867-.712 1.58-1.58 1.58h-1.39c-.328 0-.786.171-1.031.376L10.039 16.8c-.573.483-1.497.483-2.054 0l-1.292-1.104c-.246-.205-.712-.377-1.031-.377H4.23c-.867 0-1.58-.712-1.58-1.579v-1.399c0-.319-.163-.785-.367-1.023l-1.105-1.3c-.474-.565-.474-1.481 0-2.046l1.105-1.3c.204-.246.368-.705.368-1.024V4.267c0-.868.712-1.58 1.579-1.58h1.415c.328 0 .786-.171 1.031-.376l1.301-1.113ZM7 11l4-4M11 11 7 7"/>`;

  const toastHTML = `
      <div class="mt-10 ${className} form__message inline-flex align-center" tabindex="-1">
        <svg width="18" height="18" fill="none" class="flex-auto">
          <g stroke="${iconColor}" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.3">
            ${iconPath}
          </g>
        </svg>
        <span class="ml-5">${message}</span>
      </div>
    `;

  showToast(toastHTML, 3000, modalType);
};
